// Tento bundle se dodatečně připojí na stránce typu článek podle TWIG proměnné isArticle

import * as featuresArticleDetail from './featureCollections/featuresArticleDetail';

const importedModules = {
  ...featuresArticleDetail,
};
const results = Object.values(importedModules).map((func) => func());

Promise.all(results).then(
  () => {},
  () => {}
);
